export function FormField({ label, children, required }) {
  return (
    <div className="mb-4">
      <label className="block text-xs uppercase tracking-wider text-white/40 font-medium mb-1.5">
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      {children}
    </div>
  );
}
